<template>
  <div class="company-page-content">
    <banner>
      智慧化民生服务的领航者
    </banner>

    <div class="panel-main">
      <div class="panel-content static-title">
        <h1>公司简介</h1>
      </div>
    </div>
    <!--公司简介-->
    <div class="panel-main comp-synopsis">
      <div class="panel-content">
        <div class="public-layout-table2">
          <div class="panel-item">
            <div class="comp-synopsis-sheet">
              <h2>北京一维大成科技有限公司</h2>
              <h4>BEIJING  EWAY  DACHENG  TECHNOLOGY  CO.,LTD</h4>
              <p>北京一维大成科技有限公司（简称“一维科技”）成立于2002年，致力于政府民生工程领域的信息化建设。是一家以生物认证和人工智能为技术核心，以大数据分析为支撑，以民生业务为载体的创新型公共服务提供商。</p>
              <p>公司拥有业内领先的自主核心技术和持续提升的研发能力，致力于推动生物识别、人工智能和数据智能化分析等前沿科技与传统行业相结合的应用进程，为人们提供一种更加智能、便捷的生活和工作方式。</p>
              <p>一维科技拥有一支由高学历、高素质人才组成的专业团队。核心成员来自于国际商业机器公司、暴风影音、乐视等企业。传统巨匠碰撞互联网新俊，让大家在国际视野的起点上洞察行业及技术发展趋势，紧跟前沿技术，发挥创新能力，树立起行业内以前沿技术带动业务发展的产品创新之路。</p>
              <p>一维科技始终以产品为先，秉持“科技驱动、业务为要、跨界创新”的产品理念，为客户提供生物识别身份认证、职业培训云平台、智慧公共服务平台、智慧医保等系列解决方案。广泛服务于社会保障、公共就业、医疗卫生、教育考试等诸多行业，引领了传统行业的创新之路。</p>
            </div>
          </div>
          <div class="panel-item">
            <div class="img-wrapper">
              <img src="../../static/images/company/about-company.png" alt="公司简介" />
            </div>
            <p><label>价值观：</label>客户为本 创新成长 合作共赢</p>
            <p><label>愿&nbsp;&nbsp;&nbsp;&nbsp;景：</label>重塑“互联网+”时代的智能入口<br/>做数据驱动的智慧化民生服务提供商</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Banner from '../components/Banner.vue';
  export default {
    data () {
      return {
      }
    },
    components: {
      Banner
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .company-page-content {
    background: #f4f4f4;
    .pulic-banner-container {
      background-image: url('../assets/images/banners/bg-company.jpg');
      margin-bottom: 50px;
      .banner-content .banner-txt{
        font-size: 30px;
      }
    }

    .static-title{
      text-align: center;
      line-height: 38px;
      font-size: 20px;;
      h1{
        display: inline-block;
        padding-left: 36px;
        font-weight: bold;
        background: url('../assets/images/i-company.png') no-repeat left center;
      }
    }

    .panel-main{
      h2{
        color: #484848;
        font-size: 20px;
        line-height: 1em;
        text-align: center;
      }
      h4{
        font-size: 14px;
        color: #a8a8a8;
        margin-top: 6px;
        margin-bottom: 40px;
        font-weight: lighter;
        text-align: center;
      }
      .public-layout-table2{
        .panel-item{
          &:first-child{
            width: 58.18%;
          }
          width: 41.82%;
        }
      }
      /*公司简介*/
      &.comp-synopsis{
        padding-top: 85px;
        padding-bottom: 70px;
        .comp-synopsis-sheet{
          padding-left: 22px;
          padding-right: 60px;
          h2, h4{
            text-align: left;
          }
          p{
            color: #515151;
            font-size: 14px;
            line-height: 1.8em;
            margin-bottom: 20px;
          }
        }
        .img-wrapper{
          width: 447px;
          height: 325px;
          margin-top: 60px;
          margin-bottom: 22px;
          img{
            display: block;
            max-width: 100%;
          }
          & ~ p{
            color: #555555;
            font-size: 14px;
            line-height: 1.8em;
            width: 295px;
            margin-bottom: 8px;
            margin-left: 70px;
            label{
              width: 4em;
              text-align: right;
              float: left;
              margin-left: -4em;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/CompanyProfile.vue